import { useTranslation } from "react-i18next";

import Modal from "src/components-v2/Modal";

import LogoFlowFlip from "src/assets/images/common/logo-flowflip.png";

export type TransferInfoModalProps = {
  /**
   * Set show or hide modal
   */
  showModalInfo: boolean;

  /**
   * Modal toggle function
   */
  toggle: Function;
};

function TransferInfoModal(props: TransferInfoModalProps) {
  const { showModalInfo, toggle } = props;
  const { t } = useTranslation("transaction");

  return (
    <Modal title={t("summary.modal.info.title")} show={showModalInfo} onClose={() => toggle(false)} closeOnOverlay>
      <img src={LogoFlowFlip} alt="flow-flip" className="u-w-full u-pt-2 u-pb-6 u-px-8" />
      <p>{t("summary.modal.info.desc")}</p>
    </Modal>
  );
}

export default TransferInfoModal;
